

export const STATS_TYPE = [
  'age',
  'branches',
  'nationality',
  'gender'
]